export default __webpack_public_path__ + "static/media/Legguards of the Dark Messenger.47be3911.jpg";